import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from '../auth/AbEnvironment';
import Address from '../ui/Address';

import { Button, FormControl, Grid,
         Input, InputLabel, Paper, TextField, Typography
} from '@mui/material';

import AccountCreateMutation from './AccountCreateMutation';
import PageTitle from '../ui/PageTitle';
import SavingSpinner from '../ui/SavingSpinner';
import AppBindStyles from '../../AppBindStyles';
import AccountSearchFetch from './AccountSearchFetch';

const abEnvironment = new AbEnvironment();
const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    button: {
      marginTop: 15,
      marginBottom: 15,
    },
    textField: {
      margin: 'theme.spacing(1)',
      marginBottom: 6,
    },
  });
  
class VendorCreate extends Component {
    state = {
      dupeAccountName: null,
      showSpinner: false,
      parentId: abEnvironment.getUserAttribute('a_id'),
      accountType: 1,
      accountNum: '',
      accountName: '',
      description: 'New account',
      contactLastName: '',
      contactFirstName: '',
      contactEmail: '',
      contactPhone: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      postalCode: ''
    }

    goBack() {
      this.props.history.goBack();
    }
    
     goTo(route) {
        this.props.history.replace(`/${route}`);
    }
    
    showSpinner() {
      return this.state.showSpinner;
    }
    
    setCountry    = (country)    => { this.setState({country:    country}); }  
    setRegion     = (region)     => { this.setState({state:      region}); }  
    setCity       = (city)       => { this.setState({city:       city}); }  
    setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
    setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
    setAddress2   = (address2)   => { this.setState({address2:   address2}); }  
    
    render() {
        const { isAuthenticated, isAuthenticatedAppBind, needAssent } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedAppBind() || needAssent()) {
          let address = {
            country:    this.state.country,
            state:      this.state.state,
            city:       this.state.city,
            postalCode: this.state.postalCode,
            address1:   this.state.address1,
            address2:   this.state.address2
          };
          let regionLabel = "Region";

          return (
            <Grid container spacing={3} direction="row" justifyContent="flex-start">
              <Grid item xs={12}>
                <PageTitle title="Add a new vendor" showBackButton={true} name="Accounts" noMargin={true} history={this.props.history}/>
              </Grid>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Grid container spacing={2} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                      <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                        Account
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl required={true}>
                        <TextField id="vendor-name" value={this.state.accountName}
                          label="Vendor account name"
                          required={true}
                          className={classes.textField}
                          error={this.state.dupeAccountName}
                          helperText={this.state.dupeAccountName ? 'A vendor already exists by this name.' : ''}
                          onBlur={this.validateVendorName}
                          onChange={(e) => this.setState({ accountName: e.target.value, dupeAccountName: null})}/>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl >
                        <TextField id="account-num"
                          value={this.state.accountNum} 
                          label="Account number"
                          onChange={(e) => this.setState({ accountNum: e.target.value })}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl>
                        <InputLabel htmlFor="description">Description</InputLabel>
                        <Input id="description" value={this.state.description} 
                              onChange={(e) => this.setState({ description: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                        Primary contact
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="first-name">First name</InputLabel>
                        <Input  data-recording-ignore="mask" id="first-name" value={this.state.contactFirstName}
                          onChange={(e) => this.setState({ contactFirstName: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="last-name">Last name</InputLabel>
                        <Input  data-recording-ignore="mask" id="last-name" value={this.state.contactLastName}
                          onChange={(e) => this.setState({ contactLastName: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="email">Email</InputLabel>
                        <Input  data-recording-ignore="mask" id="email" value={this.state.contactEmail}
                              onChange={(e) => this.setState({ contactEmail: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl>
                        <InputLabel htmlFor="phone">Phone</InputLabel>
                        <Input  data-recording-ignore="mask" id="phone" value={this.state.contactPhone}
                              onChange={(e) => this.setState({ contactPhone: e.target.value })} />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                        Mailing address
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Address
                        address={address}
                        regionLabel={regionLabel}
                        setCountryCodeState={this.setCountry}
                        setRegionCodeState={this.setRegion}
                        setCityState={this.setCity}
                        setPostalCodeState={this.setPostalCode}
                        setAddress1State={this.setAddress1}
                        setAddress2State={this.setAddress2}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      { !this.showSpinner() && 
                      <Button variant="contained" 
                        color="primary" 
                        className={classes.button}
                        disabled={this.state.accountName.length === 0 || this.state.dupeAccountName === null || this.state.dupeAccountName}
                        onClick={() => {this._createVendor()}}>
                        Save
                      </Button>
                      }
                      {this.showSpinner() &&
                      <Button color="primary" variant="contained" >
                        <SavingSpinner/></Button>
                      }
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          );
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

    /**
     * Validate that entered vendor name doesn't match characters for an existing VENDOR account 
     * ("types array" just uses 1 to specify check against vendors)
     * @returns {Promise} object waiting on return from "account name search" action
     *     (to be used in create vendor for synchronizing validation with mutation) 
     */
    validateVendorName = () => {
      let vendorFound = false;
      let accountName = this.state.accountName;
      AccountSearchFetch.fetch(this.state.accountName).toPromise()
      .then(response => {
        //fetch comeback, check for nodes and compare name.
        let accountsReturned = response.accountsearchbyaccountnameplusorder.nodes;

        for (let i = 0; i < accountsReturned.length; i++) {
          //only check vendors; matching customer/reseller/admin/etc. account names can be similar.
          if (accountsReturned[i].accountType === 1) {
            let currentAccountName = accountsReturned[i].accountName;
            if (currentAccountName.toLowerCase() === accountName.toLowerCase()) {
              //this already exists; set flag used for highlighting the error.
              vendorFound = true;
              this.setState({
                dupeAccountName : true
              });
              break;
            }
          }
        }

        //ended loop, is vendor found? if no, reset the state variable...
        if (!vendorFound) {
          this.setState({
            dupeAccountName : false
          });
        }
      }).catch(error => {
        //if error, return nothing so that the "create" step knows to fail.
        // console.log('Account name validation error: ' + error);
        return;
      });
    };

    _createVendor = () => {
      this.setState({ showSpinner: true });

      //check state after validate step; if updated state, return.
      if (this.state.dupeAccountName) {
        this.setState({ showSpinner : false});
        return;
      }

      const { parentId, accountType, accountNum, accountName, description,
              contactLastName, contactFirstName, contactEmail, contactPhone,
              address1, address2, city, state, country, postalCode } = this.state;

      AccountCreateMutation.commit(parentId, accountType, accountNum, accountName, description, 
                                    contactLastName, contactFirstName, contactEmail, contactPhone,
                                    address1, address2, city, state, country, postalCode)
      .then(response => {
        let theId = response.createAccountT.accountT.accountId;
        // console.log('Reseller create mutation complete');
        this.setState({ showSpinner: false });
        let replaceUrl = 'vendor?accountId=' + theId;
        this.goTo(replaceUrl);
      })
      .catch(error => {
        // console.log('Reseller create mutation error: ' + error);
        this.setState({ showSpinner: false });
        this.goBack();
      });

    }
}

VendorCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(VendorCreate);